export { default } from './PartiuGpChances';
